// react router
import { Link } from 'react-router-dom'

import {
    Footer,
    FooterContainer,
    Row,
    Col,
    MenuHeader,
    List,
    Item,
    FooterCopyRightContainer,
    FooterLogoContainer,
    FooterCopyRightLogo,
    Logo,
    FooterCopyRightRight,
    FooterCopyRightLinkContent,
    FooterCopyRightText,
    FooterCopyRightLink,
} from "./styles";
import styled from "styled-components";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import React from "react";
import { Subscribe } from "./includes";

// logo
import stLogoFooter from 'assets/images/footerLogo.png'

function Theme1Footer() {
    return (
        <>
            <div className="footer-container mt-auto">
                <Subscribe />
                <Footer>
                    <FooterContainer className="container">
                        <Row>
                            <Col>
                                <MenuHeader>Our Company</MenuHeader>
                                <List>
                                    <Item className="mb-1">
                                        <Link
                                            to="/about-us"
                                            className="text-white text-decoration-none st-fs-12"
                                        >
                                            About Us
                                        </Link>
                                    </Item>
                                    <Item className="mb-1">
                                        <Link
                                            to="/contact-us"
                                            className="text-white text-decoration-none st-fs-12"
                                        >
                                            Contact Us
                                        </Link>
                                    </Item>
                                </List>
                            </Col>

                            <Col>
                                <MenuHeader>Important Links</MenuHeader>
                                <List>
                                    {/* <Item className="mb-1">
                                    <Link
                                        to="/content/our-blogs"
                                        className="text-white text-decoration-none st-fs-12"
                                    >
                                        Our Blogs
                                    </Link>
                                </Item> */}
                                    <Item className="mb-1">
                                        <Link
                                            to="/content/faqs"
                                            className="text-white text-decoration-none st-fs-12"
                                        >
                                            FAQs
                                        </Link>
                                    </Item>
                                </List>
                            </Col>

                            <Col>
                                <MenuHeader>Important Links</MenuHeader>
                                <List>
                                    <Item className="mb-1">
                                        <Link
                                            to="/content/terms-and-conditions"
                                            className="text-white text-decoration-none st-fs-12"
                                        >
                                            Terms and Conditions
                                        </Link>
                                    </Item>
                                    <Item className="mb-1">
                                        <Link
                                            to="/content/privacy-policy"
                                            className="text-white text-decoration-none st-fs-12"
                                        >
                                            Privacy Policy
                                        </Link>
                                    </Item>
                                    <Item className="mb-1">
                                        <Link
                                            to="/content/shipping-policy"
                                            className="text-white text-decoration-none st-fs-12"
                                        >
                                            Shipping Policy
                                        </Link>
                                    </Item>
                                </List>
                            </Col>

                            <Col className="social-link">
                                <MenuHeader>Social Media</MenuHeader>
                                <List>
                                    <a
                                        href="https://www.facebook.com/ruhlisticdecor"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-white text-decoration-none st-fs-12"
                                    >
                                        <FaFacebookF
                                            style={{
                                                color: "#ccc",
                                                fontSize: "20px",
                                                margin: "0 5px",
                                            }}
                                        />
                                    </a>
                                    <a
                                        href="https://www.instagram.com/ruhlisticdecor/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-white text-decoration-none st-fs-12"
                                    >
                                        <FaInstagram
                                            style={{
                                                color: "#ccc",
                                                margin: "0 15px",
                                                fontSize: "20px",
                                            }}
                                        />
                                    </a>
                                    <a
                                        href="https://twitter.com/ruhlisticdecor"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-white text-decoration-none st-fs-12"
                                    >
                                        <FaTwitter
                                            style={{
                                                color: "#ccc",
                                                fontSize: "20px",
                                                margin: "0 5px",
                                            }}
                                        />
                                    </a>
                                </List>
                            </Col>
                        </Row>

                        <FooterCopyRightContainer>
                            <FooterLogoContainer>
                                <FooterCopyRightLogo>
                                    <Logo src={stLogoFooter} />
                                </FooterCopyRightLogo>
                            </FooterLogoContainer>
                            <FooterCopyRightRight>
                                <FooterCopyRightLinkContent>
                                    © {new Date().getFullYear()} Ruhlistic. All rights reserved.
                                    <FooterCopyRightLink>
                                        <Link to="/content/terms-and-conditions">
                                            Terms and Conditions
                                        </Link>
                                    </FooterCopyRightLink>
                                    <FooterCopyRightLink>
                                        <Link to="/content/privacy-policy">
                                            Privacy Policy
                                        </Link>
                                    </FooterCopyRightLink>
                                </FooterCopyRightLinkContent>
                                <FooterCopyRightText>
                                    If you are using a screen reader and are having
                                    problems using this website, please call +1
                                    (678) 237-3520 for assistance.
                                </FooterCopyRightText>
                            </FooterCopyRightRight>
                        </FooterCopyRightContainer>
                    </FooterContainer>
                </Footer>
            </div>
        </>
    );
}
export default Theme1Footer;
